import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

export type BuyInvoiceProductDataType = Partial<ApiSchema["BuyInvoiceProduct"]["type"] & EDocumentProductDataType>;
export const BuyInvoiceProductApi = new GenericModelApi<"BuyInvoiceProduct", BuyInvoiceProductDataType>("BuyInvoiceProduct", "codigo");